import { Box } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCategoriesAction } from "../../store/actions/categories/index";
import CategoriesBar from "./components/CategoriesBar";
import Category from "./components/Category/Category";
import Events from "./components/Events/Events";
import VideoPlayer from "./components/VideoPlayer";

export default function Home() {
  const dispatch = useDispatch();

  const [selectedCategory, setSelectedCategory] = useState("all");

  const categories = useSelector((s) => s?.categories?.data);
  const loading = useSelector((s) => s?.categories?.loading);

  const handleCategoryClick = useCallback(
    (value) => setSelectedCategory(value),
    []
  );

  const fetchCategories = useCallback(
    (page = 1) => {
      getCategoriesAction({ page })(dispatch);
    },
    [dispatch]
  );

  useEffect(() => fetchCategories(), [fetchCategories]);

  return (
    <Box>
      <VideoPlayer />

      <CategoriesBar
        onCategoryClick={handleCategoryClick}
        selectedCategory={selectedCategory}
      />

      <Events />
      {selectedCategory === "all" ? (
        <>
          {categories[0] && <Category category={categories[0]} />}

          {categories[1] && (
            <Category
              category={categories[1]}
              titleBg="/images/home/divider1.png"
            />
          )}

          <Box sx={{ width: 1, height: "216px", my: 7 }}>
            <img
              src="/images/home/divider2.png"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center",
              }}
              alt=""
            />
          </Box>

          {categories[2] && <Category category={categories[2]} />}

          {<Category other titleBg="/images/home/divider1.png" />}
        </>
      ) : (
        <Category category={selectedCategory} />
      )}
    </Box>
  );
}
